import { User } from "./user.model";

export interface Revision {
  id: string;
  title: string;
  gcsRefId: string;
  version: number;
}
